import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { PasswordStrengthBar } from './PasswordStrength.styles';
import {
  PasswordStrengthLevel,
  PasswordStrengthProps,
  PasswordStrengthValues,
} from './PasswordStrength.types';

const PasswordStrength: React.FC<PasswordStrengthProps> = ({
  currentLevel,
  error,
}) => {
  const theme = useTheme();
  const intl = useIntl();

  const colorByStrength = {
    [PasswordStrengthLevel.Weak]: theme.palette.error.main,
    [PasswordStrengthLevel.Medium]: theme.palette.warning.main,
    [PasswordStrengthLevel.Strong]: theme.palette.success.main,
    [PasswordStrengthLevel.None]: theme.palette.secondary[200],
  };

  const { level, color, textValue } = useMemo(() => {
    return {
      level: error ? PasswordStrengthLevel.Strong : currentLevel,
      color: error ? theme.palette.error.main : colorByStrength[currentLevel],
      textValue:
        error ||
        intl.formatMessage({
          id: `signUp.form.passwordStrength.${currentLevel}`,
        }),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLevel, error]);

  return (
    <Flex mt={2} flex={1}>
      <Flex
        flex={1}
        flexDirection='row'
        justifyContent='space-between'
        alignItems='center'
      >
        <PasswordStrengthBar
          active={
            PasswordStrengthValues[level] >=
            PasswordStrengthValues[PasswordStrengthLevel.Weak]
          }
          color={color}
        />
        <PasswordStrengthBar
          active={
            PasswordStrengthValues[level] >=
            PasswordStrengthValues[PasswordStrengthLevel.Medium]
          }
          color={color}
        />
        <PasswordStrengthBar
          active={
            PasswordStrengthValues[level] >=
            PasswordStrengthValues[PasswordStrengthLevel.Strong]
          }
          color={color}
        />
      </Flex>
      <Flex marginLeft={4}>
        <Text variant='h6' fontWeight='fontWeightMedium' color={color}>
          {textValue}
        </Text>
      </Flex>
    </Flex>
  );
};

export default PasswordStrength;
